export { default } from './SectionPosts';